import { IShopQuoteLineItem } from "api/types/shop_quote/quote_line_item";

export enum ActionType {
  UPDATE_SHOP_QUOTE_LINE_ITEM = "UPDATE_SHOP_QUOTE_LINE_ITEM",
  SET_SELECTED_SHOP_LINE_ITEM = "SET_SELECTED_SHOP_LINE_ITEM"
}

interface IUpdateShopQuoteLineItem {
  type: ActionType.UPDATE_SHOP_QUOTE_LINE_ITEM,
  payload: IShopQuoteLineItem
}

interface ISetSelectedLineItem {
  type: ActionType.SET_SELECTED_SHOP_LINE_ITEM,
  payload: IShopQuoteLineItem
}

export type Action = IUpdateShopQuoteLineItem | ISetSelectedLineItem;
